export { default as VehicleList } from './List';
export { default as VehicleCreate } from './Create';
export { default as VehicleUpdate } from './Create';
export { default as VehicleDetails } from './Create';
